import { DependencyList, EffectCallback, useEffect, useRef } from "react";

function useEffectAfterMount(
  callback: EffectCallback,
  dependencies: DependencyList
) {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) {
      return callback();
    }
    if (!mounted.current) mounted.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}

export default useEffectAfterMount;
